// @flow
import React from "react";
import style from "./style.module.scss";
import { Icon, PhoneFilled, FastEmail } from "@2po-c21/components";

type Props = {
    onClickVisitProperty: () => void,
    contactText?: string,
    phoneNumber?: string,
    visitPropertyBtnText?: string,
};

const PropertyButtonOverlay = ({
    onClickVisitProperty,
    phoneNumber,
}: Props) => {
    return (
        <div className={style.propertyButtonOverlayContainer}>
            <a
                onClick={(e) => onClickVisitProperty && onClickVisitProperty(e)}
                className={style.contactButton}
            >
                <Icon icon={FastEmail} variant="white" size="sm" />
            </a>
            {phoneNumber && (
                <a
                    className={style.agencyContactButton}
                    href={`tel:${phoneNumber}`}
                >
                    <Icon icon={PhoneFilled} size="sm" />
                </a>
            )}
        </div>
    );
};

export default PropertyButtonOverlay;
